import { type ReactNode, useState } from "react";
import { Helmet } from "react-helmet-async";
import { cn } from "../../lib/utils";
import { BreadcrumbContextProvider, BreadcrumbUI } from "../Breadcrumb";
import { SideBarUI } from "../SideBar";

type LayoutProps = {
  children?: ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="h-screen flex overflow-hidden">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Helmet>
      <SideBarUI
        isSidebarOpen={isSidebarOpen}
        onToggleSidebar={() => setIsSidebarOpen(prev => !prev)}
        className={cn(
          "flex-none transition-all duration-300 ease-in-out relative",
          isSidebarOpen ? "w-48" : "w-16",
        )}
      />
      <div
        id="layout-content-scroll"
        className="flex-1 overflow-y-auto bg-layout-base"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <BreadcrumbContextProvider>
            <BreadcrumbUI className="mb-2"></BreadcrumbUI>
            {children}
          </BreadcrumbContextProvider>
        </div>
      </div>
    </div>
  );
};

export default Layout;
